import {attributeKeyToId, stringToAttributeId} from './components/spc/util/spcUtils';

const aeto = [
	[
		'root::CX_Region'
	],
	[
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_ColourTemperature_2'
	],
	[
		'root::EB_MotionSensor_1'
	],
	[
		'root::HS_Construction',
		'root::HS_HousingSize',
		'root::LU_SolarUnitHeight'
	],
	[
		'root::HS_HousingHeight'
	],
	[
		'root::LE_LuminairePositionHeight_1',
		'root::LE_LightDistribution_1',
	],
	[
		'root::LE_LuminairePositionHeight_2',
		'root::LE_LightDistribution_2'
	],
	[
		'root::LE_LuminairePositionAngle_1',
		'root::LE_LuminairePositionAngle_2',
		'root::LE_LuminairePositionHeightSU_1',
		'root::LE_LuminairePositionHeightSU_2',
		'root::LU_SolarUnit'
	]
];

const olivio = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
		'root::LE_ReflectorColour_1'
	],
	[
		'root::LE_Accessories_1'
	],
	[
		'root::EB_Control_1',
		'root::EB_ConstantLumenTechnology_1',
		'root::EB_Zhaga_1',
		'root::EB_ElectricalProtectionClass_1',
		'root::LE_DimmingLevel_1',
	]
];

const aira = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_CircularBaseProfile',
		'root::LE_OpticalVersion_1'
	],
	[
		'root::HS_HousingSize',
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1'
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const alpha = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1'
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const anatar = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const arca = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const astro = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_OpticalVersion_1',
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const avanza = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::LE_OpticalVersion_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const axeo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const aya = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const beta = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const discera = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const elo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1'
	],
	[
		'root::LE_LightDistribution_1',
	],
	[
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const inula = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const jessica = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const lanova = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const lif = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_ColourTemperature_1',
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1',
		'root::LE_LightDistribution_1'
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const lifPath = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_ReflectorColour_1',
		'root::LE_LightDistribution_1'
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const lukida = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const mistella = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const rondero = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const saturn = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const sombreo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const tal = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const tessia = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const trigo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_OpticalVersion_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const tritec = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1'
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const valetta = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const yloo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1'
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];

const wizardAttributeRelations = {

	LineComposition: [
		[
			'shared::Context::CX_Region',
			'shared::Context::CX_Usage',
			'shared::ProductType::HS_HousingType',
		],
		[
			'shared::PoleSpecialLine::HS_Construction',
		],
		[
			'shared::Context::LU_Filter_LightEmission_Uplight',
			'shared::Context::LU_Filter_LightEmission_CA',
			'root::LightEngine_1::LE_LightDistribution',
			'root::LightEngine_1::LE_ColourTemperature',
			'root::LightEngine_1::LE_ReflectorColour',
			'root::LightEngine_1::LE_OpticalVersion',
			'root::LightEngine_1::LE_LightEngineModuleSize',
		],
		[
			'shared::HousingLuminaire::HS_HousingConnection'
		],
		[
			'shared::PoleBasic::HS_Height',
			'shared::PoleBasic::HS_Base',
			'shared::PoleBasic::HS_NumberPoleDoors',
			'shared::ColourCoating::HS_HousingColour',
			'shared::ColourCoating::HS_HousingCoating',
		],
		[
			'root::EBlock_1::EB_Control',
			'root::EBlock_1::EB_ElectricalProtectionClass',
			'shared::Zhaga::HS_HousingZhaga',
			'root::EBlock_1::EB_ConstantLumenTechnology',
		],
		[
			'root::LightEngine_1::LE_LightEmission_Uplight',
			'root::LightEngine_1::LE_LightEmission_CA'
		]
	],

	AetoExtern: aeto,

	OlivioExtern: olivio,
	OlivioUniversalExtern: olivio,
	OlivioBollardExtern: olivio,

	AiraPoleTopExtern: aira,
	AiraPendantExtern: aira,
	AiraCatenaryExtern: aira,

	AlphaExtern: alpha,

	AnatarExtern: anatar,

	ArcaExtern: arca,

	AstroExtern: astro,

	AvanzaExtern: avanza,

	AyaPoleTopExtern: aya,
	AyaPendantExtern: aya,
	AyaCatenaryExtern: aya,

	AxeoExtern: axeo,

	BetaPoleTopExtern: beta,
	BetaPendantExtern: beta,

	DisceraExtern: discera,

	EloPoleTopExtern: elo,
	EloBollardExtern: elo,
	EloColumnExtern: elo,
	EloWallSurfaceExtern: elo,

	InulaBollardExtern: inula,
	InulaColumnExtern: inula,

	JessicaExtern: jessica,

	LanovaPoleTopExtern: lanova,
	LanovaCatenaryExtern: lanova,

	LifTopElementExtern: lif,
	LifPathwayModuleExtern: lifPath,
	LifFacadeModule: lif,
	LifTwinspotModule: lif,

	LukidaExtern: lukida,

	MistellaExtern: mistella,

	RonderoExtern: rondero,

	SaturnPoleTopExtern: saturn,
	SaturnBollard: saturn,

	SombreoPoleLateralExtern: sombreo,
	SombreoCatenaryExtern: sombreo,

	TalExtern: tal,

	TessiaExtern: tessia,

	TrigoExtern: trigo,

	TritecReplacementKitsExtern: tritec,

	ValettaExtern: valetta,

	YlooPoleTopExtern: yloo,
	YlooPoleLateralExtern: yloo,
	YlooPendantExtern: yloo,
	YlooCatenaryExtern: yloo,

};

function arrayToWizardAttributeRelations(array) {
	return array.map(a => ({
		attributes: a.map(attributeKeyToId)
	}));
}

export function getWizardAttributeRelations(deploymentName) {
	if (wizardAttributeRelations.hasOwnProperty(deploymentName)) {
		return arrayToWizardAttributeRelations(wizardAttributeRelations[deploymentName]);
	} else {
		return null;
	}
}
